// 인증 실패(401) 및 필수값 미입력 시 노출
export const LOGIN_ERROR_MESSAGE = "이메일 또는 비밀번호가 올바르지 않습니다.";
// 계정 상태 문제(403 ACCOUNT_INACTIVE) — 입력값 잘못이 아니라 토스트로 안내
export const LOGIN_INACTIVE_MESSAGE =
  "사용할 수 없는 계정이에요. 관리자에게 문의해 주세요.";
// 형식 위반(422) — 공백 포함 / 50자 초과
export const LOGIN_EMAIL_FORMAT_MESSAGE =
  "이메일은 공백 없이 50자까지 입력할 수 있어요.";
export const LOGIN_FORM_DEFAULT = {
  email: "",
  password: "",
};
